import { OverseasMissionFormValues } from './types';

export const initialValuesForm: OverseasMissionFormValues = {
  employeeNumber: undefined,
  employeeName: '',
  placeOfTravel: '',
  dateOfTravel: '',
  returnDate: '',
  totDays: '',
  purposeOfTravel: '',
  approvedTravelAmount: null,
  designation: '',
  currentLocation: '',
  country: null,
  sponsoredBy: null,
  sponsoredByExtra: '',
};
